import React, { useEffect, useState } from 'react';
import { useUserState } from '../hooks/useUserState';
import { userProfilesStateService } from '../services/UserProfilesStateService';

const AppStarted: React.FC = () => {
  const userState = useUserState();
  const [isProcessed, setIsProcessed] = useState(false);

  useEffect(() => {
    // Only run once and only if we have user data
    if (!isProcessed && userState.id) {
    //   const initializeUserProfile = async () => {
    //     try {

    //       console.log('Initializing user profile for user:', userState.id);

    //       // Create a profile for the user, if one already exists, it will be ignored
    //       const result = await userProfilesStateService.createUserProfile(userState.id!);
          
    //       // Mark as processed so we don't try again
    //       setIsProcessed(true);
          
    //       console.log('User profile initialization completed', result);
    //     } catch (error) {
    //       console.error('Error initializing user profile:', error);
    //     }
    //   };

    //   initializeUserProfile();
    }
  }, [userState, isProcessed]);

  // Render nothing - this is a utility component with no visual output
  return null;
};

export default AppStarted; 